@if (statusInfo(); as info) {
  <pr-icon-chip [icon]="info.icon" [iconClass]="info.iconClass">
    {{ info.label }}
  </pr-icon-chip>
}
